/* Urma – Boss-style header behaviour for Dawn's mega menu.
   - Desktop with a mouse: open on hover (with a short close delay), clicking the
     top item goes to its page, hovering/focusing a left-column item swaps the panel.
   - Touch: Dawn's normal tap-to-open; first tap on a left-column item swaps the
     panel, second tap follows the link. */
(() => {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  const setTab = (details, key) => {
    details.querySelectorAll('[data-urma-tab]').forEach((a) => {
      a.classList.toggle('is-active', a.dataset.urmaTab === key);
    });
    details.querySelectorAll('[data-urma-panel]').forEach((p) => {
      p.classList.toggle('is-active', p.dataset.urmaPanel === key);
    });
  };

  const toggle = (details) => details.querySelector('summary').click();

  const init = () => {
    const all = document.querySelectorAll('details.urma-mega');
    all.forEach((details) => {
      if (details.dataset.urmaReady) return;
      details.dataset.urmaReady = '1';

      details.querySelectorAll('[data-urma-tab]').forEach((a) => {
        const go = () => setTab(details, a.dataset.urmaTab);
        a.addEventListener('mouseenter', go);
        a.addEventListener('focus', go);
        a.addEventListener('click', (e) => {
          if (!canHover.matches && !a.classList.contains('is-active')) {
            e.preventDefault();
            go();
          }
        });
      });

      const summary = details.querySelector('summary');
      summary.addEventListener('click', (e) => {
        // A real mouse click on an already hover-opened item follows the link, like Boss.
        if (e.isTrusted && canHover.matches && details.open && summary.dataset.urmaUrl) {
          e.preventDefault();
          window.location.href = summary.dataset.urmaUrl;
        }
      });

      const item = details.closest('li');
      let closeTimer;
      item.addEventListener('mouseenter', () => {
        if (!canHover.matches) return;
        clearTimeout(closeTimer);
        document.querySelectorAll('details.urma-mega[open]').forEach((other) => {
          if (other !== details) toggle(other);
        });
        if (!details.open) toggle(details);
      });
      item.addEventListener('mouseleave', () => {
        if (!canHover.matches) return;
        closeTimer = setTimeout(() => {
          if (details.open) toggle(details);
        }, 180);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ---------- Urma cart drawer: one-click add-ons + first-open refresh ---------- */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // One-click "Tilføj" for add-on products in the cart drawer.
  document.addEventListener('click', async (e) => {
    const button = e.target.closest('[data-urma-upsell]');
    if (!button) return;
    e.preventDefault();
    const id = Number(button.dataset.urmaUpsell);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id, quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });
      const state = await res.json();
      if (!res.ok || state.status) throw new Error(state.description || 'add failed');
      state.id = id;
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(state);
      } else {
        window.location.href = `${root}cart`;
      }
    } catch (err) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = 'Prøv igen';
    }
  });

  // The drawer printed with the page comes from Dawn's snippet; refresh it once from the
  // cart-drawer section so the Urma additions are present the first time it opens.
  const refresh = async () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.classList.contains('is-empty') || drawer.querySelector('.urma-cart-extras')) return;
    try {
      const html = await (await fetch(`${root}?section_id=cart-drawer`)).text();
      const src = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
      const dst = document.querySelector('#CartDrawer');
      if (!src || !dst) return;
      dst.innerHTML = src.innerHTML;
      const overlay = document.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', () => drawer.close());
    } catch (err) {
      /* keep Dawn's version */
    }
  };
  const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 1200));
  if (document.readyState === 'complete') idle(refresh);
  else window.addEventListener('load', () => idle(refresh));
})();

/* ---------- Urma: percentage sale badges ("-30 %") on cards and product page ---------- */
(() => {
  const parse = (txt) => {
    const clean = (txt || '').replace(/[^\d,.]/g, '').replace(/\./g, '').replace(',', '.');
    const n = parseFloat(clean);
    return isNaN(n) ? null : n;
  };
  const soldOut = () => (window.variantStrings && window.variantStrings.soldOut) || 'Udsolgt';
  const apply = (root) => {
    root.querySelectorAll('.price--on-sale').forEach((price) => {
      const was = parse(price.querySelector('.price__sale s .price-item--regular, .price__sale .price-item--regular')?.textContent);
      const now = parse(price.querySelector('.price__sale .price-item--sale, .price__sale .price-item--last')?.textContent);
      if (!was || !now || now >= was) return;
      const pct = Math.round((1 - now / was) * 100);
      if (pct < 1) return;
      const label = `-${pct} %`;
      const card = price.closest('.card-wrapper');
      const scope = card || price.closest('.product__info-container') || price;
      scope.querySelectorAll('.card__badge .badge, .price__badge-sale').forEach((b) => {
        if (b.textContent.trim() !== soldOut() && b.textContent.trim() !== label) b.textContent = label;
      });
    });
  };
  let t;
  const run = () => { clearTimeout(t); t = setTimeout(() => apply(document), 120); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ---------- Urma: strap width pills ("20 MM") on product images (13/10-26) ----------
   Omega-style size label over the image on product cards and on the product page.
   The width is read from the product title ("Picto silikonestrop 20 mm", "Urrem 19-20 mm").
   Only straps/bracelets get a pill: the first product word in the title decides
   (…rem/strop/strap/lænke/band → strap; …ur/ure → watch, so "Herreur med lænke - 40 mm" gets none). */
(() => {
  const SIZE = /(\d{1,2}(?:[.,]\d)?)(?:\s*[-–\/]\s*(\d{1,2}(?:[.,]\d)?))?\s*mm\b/i;
  const STRAP_WORD = /(rem|remme|strop|stropper|strap|straps|lænke|lænker|nato|band)$/;
  const WATCH_WORD = /(ur|ure)$/;
  const isStrap = (title) => {
    const words = title.toLowerCase().split(/[^a-z0-9æøå]+/).filter(Boolean);
    for (const w of words) {
      if (STRAP_WORD.test(w)) return true;
      if (WATCH_WORD.test(w)) return false;
    }
    return false;
  };
  const sizeLabel = (title) => {
    if (!title || !isStrap(title)) return null;
    const m = title.match(SIZE);
    if (!m) return null;
    return m[2] ? `${m[1]}–${m[2]} mm` : `${m[1]} mm`;
  };
  const addPill = (host, label, extra) => {
    if (!host || host.querySelector(':scope > .urma-size-pills')) return;
    host.classList.add('urma-size-host');
    const wrap = document.createElement('div');
    wrap.className = `urma-size-pills${extra ? ` ${extra}` : ''}`;
    wrap.setAttribute('aria-label', `Bredde: ${label}`);
    const pill = document.createElement('span');
    pill.className = 'urma-size-pill';
    pill.textContent = label;
    wrap.appendChild(pill);
    host.appendChild(wrap);
  };
  const apply = () => {
    // Product cards (collections, search, sliders, recommendations)
    document.querySelectorAll('.card-wrapper:not([data-urma-size])').forEach((card) => {
      card.setAttribute('data-urma-size', '');
      const heading = card.querySelector('.card__heading a, .card__heading');
      const label = sizeLabel(heading && heading.textContent.trim());
      if (label) addPill(card.querySelector('.card__inner'), label);
    });
    // Product page: first image in the gallery
    document.querySelectorAll('.product__media-wrapper:not([data-urma-size])').forEach((gallery) => {
      gallery.setAttribute('data-urma-size', '');
      const scope = gallery.closest('.shopify-section') || document;
      const title = scope.querySelector('.product__title h1, .product__title .h1, .product__title h2');
      const label = sizeLabel(title && title.textContent.trim());
      if (!label) return;
      const item = gallery.querySelector('.product__media-item');
      addPill(item && (item.querySelector('.product-media-container') || item), label, 'urma-size-pills--pdp');
    });
  };
  const style = document.createElement('style');
  style.textContent = `
    .urma-size-host { position: relative; }
    .urma-size-pills {
      position: absolute; left: 0; right: 0; bottom: 1.2rem; z-index: 2;
      display: flex; justify-content: center; flex-wrap: wrap; gap: 0.6rem;
      padding: 0 1rem; pointer-events: none;
    }
    .urma-size-pill {
      display: inline-flex; align-items: center; min-height: 2.4rem; padding: 0.2rem 1rem;
      font-size: 1.1rem; font-weight: 500; letter-spacing: 0.1em; text-transform: uppercase; line-height: 1;
      color: rgb(26, 26, 26); background: rgba(255, 255, 255, 0.92);
      border: 1px solid rgba(26, 26, 26, 0.14); border-radius: 999px;
    }
    .urma-size-pills--pdp { bottom: 2rem; }
    .urma-size-pills--pdp .urma-size-pill { min-height: 2.8rem; padding: 0.2rem 1.4rem; font-size: 1.2rem; }
  `;
  document.head.appendChild(style);
  let t;
  const run = () => { clearTimeout(t); t = setTimeout(apply, 120); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();
